
import { defineComponent } from "vue";

export default defineComponent({
	name: 'RecursiveTaxonomyButtons',
	props: {
		tax: {
			required: true,
			type: Object
		},
		slug: {
			required: true,
			type: String
		},
		groupClass: {
			required: false,
			type: String
		},
		multiSelect: {
			required: false,
			type: Boolean,
			default: true
		},
		showTerms: {
			required: false,
			type: Object,
			default: null
		}
	},
	emits: ['updateTaxonomy'],
	expose: ['reset'],
	data() {
		return {
			activeTermIds: [] as number[]
		}
	},
	methods: {
		switchId(append: number) {
			return 'vueEventsPluginSwitch' + append
		},
		updateTaxonomy(slug: string, termId: number) {
			const activeTermIndex = this.activeTermIds.indexOf(termId)

			if (false === this.multiSelect) {
				this.activeTermIds = []
			}

			if (activeTermIndex > -1) {
				if (true === this.multiSelect) {
					this.activeTermIds.splice(activeTermIndex, 1);
				}
			} else {
				this.activeTermIds.push(termId)
			}

			this.$emit('updateTaxonomy', slug, termId)
		},
		reset() {
			this.activeTermIds = []
			if (this.$refs.recursiveTaxonomyButtons) {
				(this.$refs.recursiveTaxonomyButtons as Array<object>).forEach((group: object) => {
					(group as typeof this).reset();
				});
			}
		},
	},
	mounted() {
		Object.keys(this.tax.items).forEach(index => {
			const termId = parseInt(this.tax.items[index].id)
			if (this.$route.query[this.slug + '[]']) {
				if (this.$route.query[this.slug + '[]']?.includes(termId.toString()) && false === this.activeTermIds.includes(termId)) {
					this.activeTermIds.push(termId);
				}
			}
		})
	}
})
